export default class QuestionsAnswersModel {
  constructor({
    additional_info: additionalInfo,
    answers,
    button_label: buttonLabel,
    answerDescription: description,
    answerTitle: title,
    currentStep = 1,
    key,
    bg_color: placeHolderBgColor,
    description: placeHolderDescription,
    label: placeHolderLabel,
    title: placeHolderTitle,
  }) {
    this.key = key;
    this.additionalInfo = additionalInfo;
    this.title = title;
    this.description = description;
    this.buttonLabel = buttonLabel;
    this.currentStep = currentStep;
    this.answers = answers ? Object.entries(answers)
      .reduce((acc, [answerKey, answer]) => ({ ...acc, [answerKey]: new QuestionsAnswersModel({ ...{ ...answer, answerTitle: answer.title, answerDescription: answer.description }, key: answerKey, currentStep: currentStep + 1 }) }), {}) : {};
    this.placeHolderBgColor = placeHolderBgColor;
    this.placeHolderDescription = placeHolderDescription;
    this.placeHolderLabel = placeHolderLabel;
    this.placeHolderTitle = placeHolderTitle;
  }

  getAdditionalInfo() {
    return this.additionalInfo;
  }

  getTitle() {
    return this.title;
  }

  getDescription() {
    return this.description;
  }

  getButtonLabel() {
    return this.buttonLabel;
  }

  getAnswers() {
    return Object.values(this.answers);
  }

  getListLabels() {
    return this.answers ? Object.values(this.answers).map((ans) => ({ key: ans.getKey(), value: ans.getButtonLabel() })) : [];
  }

  getCurrentStep() {
    return this.currentStep;
  }

  getPlaceHolderBgColor() {
    return this.placeHolderBgColor;
  }

  getPlaceHolderDescription() {
    return this.placeHolderDescription;
  }

  getPlaceHolderLabel() {
    return this.placeHolderLabel;
  }

  getPlaceHolderTitle() {
    return this.placeHolderTitle;
  }

  getKey() {
    return this.key;
  }

  getAnswerByKey(key) {
    if (this.getKey() === key) {
      return this;
    }
    return this.getAnswers().reduce((acc, answer) => {
      if (answer.getAnswerByKey(key)) {
        return answer.getAnswerByKey(key);
      }
      return acc;
    }, null);
  }
}
